import { ID } from '@griply/types';

export type RemapIdsOptions = {
  // Keep an id the copy does not hold instead of dropping it, e.g. the parent of a sub-task copied on its own.
  keepUnmapped?: boolean;
};

// The ids a copied document points at, swapped for the ids of their copies. Nothing left means null, never [].
export const remapIds = (
  ids: ID[] | null | undefined,
  newIds: Map<ID, ID>,
  { keepUnmapped = false }: RemapIdsOptions = {},
): ID[] | null => {
  if (!ids) {
    return null;
  }
  const remapped = ids.flatMap((id) => {
    const newId = newIds.get(id) ?? (keepUnmapped ? id : undefined);
    return newId ? [newId] : [];
  });
  return remapped.length ? remapped : null;
};
